<template>
  <router-link
    class="app-menu-item wg-no-merge"
    :class="[classes, icon]"
    :to="{ name: link }"
  >
    <span class="app-menu-item__icon iconfont" :class="icon"></span>
    {{ text }}
  </router-link>
</template>

<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    icon: string
    link: string
    text: string
    isActive: boolean
    stackOnMobile?: boolean
  }>(),
  {
    stackOnMobile: true,
  },
)

const classes = {
  'app-menu-item--active': props.isActive,
  'app-menu-item--stacked': props.stackOnMobile,
}
</script>

<style lang="scss" scoped>
.app-menu-item {
  display: flex;
  align-items: center;
  font-size: 16px;
  line-height: 20px;
  color: $c-black-2;
  position: relative;
  padding: 20px 0 20px;
  @media only screen and (max-width: $w-largest) and (min-width: $w-tablet-b) {
    white-space: nowrap;
  }
  @media only screen and (max-width: $w-max-content-width) {
    font-size: 13px;
    padding: 15px 0 15px;
  }
  &:before {
    content: '';
    display: block;
    width: 100%;
    height: 4px;
    border-radius: 10px;
    position: absolute;
    left: 0;
    bottom: 0;
    opacity: 0;
    transition: all 0.2s ease-in-out;
  }
  @include hover {
    &:before {
      opacity: 1;
      background-color: $c-border;
    }
  }
  &--active {
    &:before {
      background-color: $c-yellow;
      opacity: 1;
    }
    @include hover {
      &:before {
        background-color: $c-yellow;
        opacity: 1;
      }
    }
  }

  &__icon {
    margin-right: 4px;
    margin-bottom: 2px;
    font-size: 24px;
    position: relative;
  }
}

@media only screen and (max-width: $w-tablet-s) {
  .app-menu-item--stacked {
    flex-direction: column;
    flex-basis: 0;
    flex-grow: 1;
    padding: 0;
    font-size: 12px;
    line-height: 13px;
    text-align: center;
    letter-spacing: -0.25px;
    color: $c-black-9;
    @media only screen and (max-width: $w-370) {
      max-width: fit-content;
    }

    &:before {
      transform: translateX(-50%);
      left: calc(50% - 4px);
      top: 0px;
    }

    &__icon {
      line-height: 28px;
      margin-right: 0;
      margin-bottom: 4px;
    }

    &.idiscover:before {
      width: 18px;
      height: 18px;
      border-radius: 50%;
      left: 45%;
    }

    &.ibook:before {
      width: 13px;
      height: 13px;
      border-radius: 15%;
      top: 1px;
      left: 45%;
    }

    &.iarticles:before {
      width: 15px;
      height: 17px;
      border-radius: 15%;
      top: 1px;
    }

    &.ipodcasts:before {
      width: 15px;
      height: 15px;
      border-radius: 50%;
      top: 1px;
      left: calc(50% + 3px);
    }

    &.ilibrary:before {
      width: 18px;
      height: 12px;
      border-radius: 15%;
      top: 7px;
      left: calc(50% - 3px);
    }

    &.isearch:before {
      width: 18px;
      height: 18px;
      border-radius: 50%;
    }
  }
}

.night-mode {
  .app-menu-item {
    color: $c-dark-4;
    @media only screen and (max-width: $w-tablet-s) {
      color: $c-dark-6;
    }
    @include hover {
      &:before {
        opacity: 1;
        background-color: $c-dark-5;
      }
    }
    &:before {
      @media only screen and (max-width: $w-tablet-s) {
        background-color: rgba(255, 201, 6, 0.8);
      }
    }
  }

  .app-menu-item--active {
    color: $c-white;
    @include hover {
      &:before {
        opacity: 1;
        background-color: $c-yellow;
      }
    }
  }
  @include hover {
    color: $c-white;
  }
}
</style>
